import { render, staticRenderFns } from "./caricomp.vue?vue&type=template&id=c535502c&scoped=true&"
import script from "./caricomp.vue?vue&type=script&lang=js&"
export * from "./caricomp.vue?vue&type=script&lang=js&"
import style0 from "./caricomp.vue?vue&type=style&index=0&id=c535502c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c535502c",
  null
  
)

export default component.exports